import React, {useEffect} from 'react'
import {Outlet, Route, Routes, Navigate} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {ConfirmEmail} from './components/ConfirmEmail'
import {ForgotPassword} from './components/ForgotPassword'
import {Login} from './components/Login'
import {ResetPassword} from './components/ResetPassword'
import {UpdatePassword} from './components/UpdatePassword'

const AuthLayout = () => {
  useEffect(() => {
    document.body.classList.add('bg-body')
    return () => {
      document.body.classList.remove('bg-body')
    }
  }, [])

  return (
    <div id='auth' className='d-flex flex-column flex-xl-row flex-column-fluid position-relative overflow-hidden'>
      <div className='d-flex flex-column flex-center flex-column-fluid w-xl-50'>
        <div className='d-flex flex-center flex-column flex-column-fluid p-10 p-xl-20 z-index-2'>
          <Outlet />
        </div>
      </div>
      <div className='d-none d-xl-flex flex-column flex-center w-xl-50 p-20 z-index-1 position-relative'>
        <img
          alt='Logo'
          src={toAbsoluteUrl('/media/logos/logo_reversed.svg')}
          className='z-index-0'
          style={{
            height: `calc(100vh * 0.75)`,
            opacity: 0.1,
            filter: 'blur(5px)',
            position: 'absolute',
          }}
        />
        <div className='text-center z-index-1'>
          <h1 className='fs-3x lh-1'>GLC Demi Rakyat & Negara</h1>
          <span
            className='fs-2x lh-1'
            style={{
              fontFamily: 'Rage',
            }}
          >
            Sinergi GDRN, Lestari Bersama
          </span>
        </div>
      </div>
      <div className='bubble1'></div>
      <div className='bubble2'></div>
      <div className='bubble3'></div>
      <div className='bubble4'></div>
    </div>
  )
}

const AuthPage = () => {
  return (
    <Routes>
      <Route element={<AuthLayout />}>
        <Route path='login' element={<Login />} />
        {/* <Route path='registration' element={<Registration />} /> */}
        <Route path='forgot-password' element={<ForgotPassword />} />
        <Route path='reset-password' element={<ResetPassword />} />
        <Route path='confirm-email' element={<ConfirmEmail />} />
        <Route path='update-password' element={<UpdatePassword />} />
        {/* <Route path='resend-email-confirmation' element={<ResendEmailConfirmation />} /> */}
        <Route index element={<Login />} />
        <Route path='*' element={<Navigate to='/auth/login' replace/>} />
      </Route>
    </Routes>
  )
}

export {AuthPage}
